import type { Member } from '@/core/models/member/member'

export interface TeamListItem {
  readonly id: string
  readonly name: string
  readonly memberCount: number
}

export interface Team {
  readonly id: string
  readonly name: string
  readonly members: ReadonlyArray<Member>
}

export const TEAM_NAME_MAX_LENGTH = 100

export const teamNameErrorKey = (name: string): string | null => {
  const trimmed = name.trim()
  if (!trimmed) {
    return 'settings.organizationTeams.nameRequired'
  }
  if (trimmed.length > TEAM_NAME_MAX_LENGTH) {
    return 'settings.organizationTeams.nameTooLong'
  }
  return null
}
